module.exports = __webpack_public_path__ + "img/logo-wings-air.9039c7c5.png";